<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600"
  >
    <v-card>
      <v-toolbar
        dark
      >
        <v-toolbar-title>
          Modify Subscription - {{serialNumber}}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-select
          v-model="subscriptionPackage"
          :items="packages"
          label="select package"
          outlined
        ></v-select>
        <v-row>
          <v-col>
            <v-date-picker full-width v-if="subscriptionPackage !== 'Included'" v-model="subscriptionExpires">
            </v-date-picker>
          </v-col>
        </v-row>
        <!--
        <v-text-field
          v-model="month"
          outlined
          label="Expiration Month"
          type="number"
          :rules="monthRules"
        ></v-text-field>
        <v-text-field
          v-model="day"
          outlined
          label="Expiration Day"
          type="number"
        ></v-text-field>
        <v-text-field
          v-model="year"
          outlined
          label="Expiration Year"
          type="number"
        ></v-text-field>
        -->
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="#f5f5f5" @click="onChangeClick()">Save</v-btn>
        <v-btn color="grey lighten-1" @click="onCancelClick()">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    serialNumber: String,
    subscriptionPackage: String,
    subscriptionExpiresYear: String,
    subscriptionExpiresMonth: String,
    subscriptionExpiresDay: String,
    subscriptionExpires: String,
  },

  mounted() {
    console.log('mounted ModifyEasySubscriptionDialog');
  },

  updated() {
    console.log('updated ModifyEasySubscriptionDialog');
  },

  data() {
    const d = new Date();

    return {
      packages: [
        'Included',
        'Limited',
        'Premium + VAG',
      ],
      packageLookup: {
        Included: 0,
        Limited: 1,
        'Premium + VAG': 4,
      },
      testDate: '2023-01-01',
    };
  },

  methods: {
    onChangeClick() {
      console.log(this.serialNumber);
      console.log(this.subscriptionPackage);
      console.log(this.subscriptionExpires);

      const p = this.packageLookup[this.subscriptionPackage];
      console.log(`subscriptionPackage=${p}`);

      const d = this.subscriptionExpires.split('-');

      this.$emit('close', {
        serialNumber: this.serialNumber,
        package: p,
        month: d[1],
        day: d[2],
        year: d[0],
      });

      // this.restoreDefaults();
    },

    restoreDefaults() {
      this.newSerialNumber = '';
      this.package = '';

      const d = new Date();
      this.month = d.getMonth() + 1;
      this.day = d.getDate();
      this.year = d.getFullYear() + 1; // default 1 year of subscription
    },

    onCancelClick() {
      this.$emit('close', { serialNumber: null });
      this.newSerialNumber = '';

      this.restoreDefaults();
    },
  },
};
</script>
